export const iconFontAwesomeNatureFire = (
	<i className="fa-solid fa-fire"></i>
);
